module.exports = __webpack_public_path__ + "media/images/1-23d6e396996b437e4d7852d760b35f8b.jpg";